import {CHANGE_DATA, REMOVE_DATA, REPLACE_DATA} from '../actions/types';
import * as _ from 'lodash';

const INITIAL_STATE = {};

export default (state: Record<string, any> = INITIAL_STATE, action: ActionDataShape): Record<string, any> => {
    const {keys, value, type} = action;

    switch (type) {
        case REPLACE_DATA:
            _.set(state, keys, value);
            return state;
        case CHANGE_DATA:
            const prevValue = _.get(state, keys, null);
            if (prevValue) {
                if (_.isPlainObject(prevValue) && _.isPlainObject(value)) {
                    _.set(state, keys, {...prevValue, ...value});
                } else if (_.isArray(prevValue) && _.isArray(value)) {
                    _.set(state, keys, [...prevValue, ...value]);
                } else {
                    _.set(state, keys, value);
                }
            } else {
                _.set(state, keys, value);
            }
            return state;
        case REMOVE_DATA:
            _.unset(state, keys);
            return state;
    }
    return state;
};
